/* Dealer invoices list (Akshay 09-18 Changes 2 + 8).
 *
 * Same App Proxy lookup as the dashboard: the proxy supplies the verified
 * logged_in_customer_id, so the list is always the signed-in dealer's own.
 * The lookup needs at least one criterion, so an unfiltered visit shows the
 * last year (section setting) rather than the whole ledger.
 */
(function () {
  var app = document.getElementById('DealerInvoicesApp');
  if (!app) return;

  var PROXY = app.dataset.proxyBase || '/apps/dealer';

  /* Records follow the dealer's chosen location (dealer-dashboard.js keeps the
   * choice), else the buyer's current Shopify location. The portal checks it
   * against the login, so it can only narrow what a login may see. */
  function scopeParam() {
    var chosen = '';
    try { chosen = localStorage.getItem('oew-dealer-scope') || ''; } catch (e) {}
    return chosen || app.dataset.location || '';
  }
  var DAYS = parseInt(app.dataset.defaultDays, 10) || 365;
  var form = app.querySelector('[data-invoice-filters]');
  var el = function (sel) { return app.querySelector(sel); };

  var money = function (n) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(n) || 0);
  };
  /* Date-only values: never new Date('YYYY-MM-DD'), which renders a day early in US timezones. */
  var day = function (iso) {
    if (!iso) return '';
    var p = String(iso).split('-');
    if (p.length !== 3) return iso;
    return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };
  var isoDaysAgo = function (days) {
    var d = new Date(); d.setDate(d.getDate() - days);
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  };

  function cell(tr, cls, node) {
    var td = document.createElement('td');
    if (cls) td.className = cls;
    if (typeof node === 'string') td.textContent = node; else if (node) td.appendChild(node);
    tr.appendChild(td);
  }

  function pdfLink(inv, label) {
    var a = document.createElement('a');
    a.className = 'dash-table__view';
    a.href = PROXY + '/invoices/' + encodeURIComponent(inv.id) + '/pdf';
    a.textContent = label;
    return a;
  }

  function paramsFromForm() {
    var fd = new FormData(form);
    var p = {};
    ['q', 'from', 'to'].forEach(function (k) { var v = String(fd.get(k) || '').trim(); if (v) p[k] = v; });
    if (fd.get('open')) p.open = '1';
    return p;
  }

  function fillForm(p) {
    form.q.value = p.q || '';
    form.from.value = p.from || '';
    form.to.value = p.to || '';
    form.open.checked = p.open === '1';
  }

  var DASHBOARD_URL = app.dataset.dashboardUrl || '/pages/dashboard';
  var payEnabled = false;
  var lastRender = null;
  fetch(PROXY + '/dashboard/context' + (scopeParam() ? '?location=' + encodeURIComponent(scopeParam()) : ''), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      payEnabled = !!(d && d.invoice_pay && d.invoice_pay.enabled);
      if (payEnabled && lastRender) render(lastRender[0], lastRender[1]);
    })
    .catch(function () {});

  function render(rows, p) {
    lastRender = [rows, p];
    var tbody = el('[data-invoice-rows]');
    tbody.innerHTML = '';
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var owed = 0;

    rows.forEach(function (inv) {
      owed += Number(inv.balance) || 0;
      var tr = document.createElement('tr');
      cell(tr, null, pdfLink(inv, '#' + inv.number));
      cell(tr, 'dash-table__muted', day(inv.date));
      cell(tr, 'dash-table__muted', inv.order_number ? '#' + inv.order_number : '—');

      if (inv.due_date && inv.open) {
        var q = inv.due_date.split('-');
        var due = new Date(+q[0], +q[1] - 1, +q[2]);
        var span = document.createElement('span');
        span.className = due < today ? 'dash-due dash-due--past' : 'dash-due';
        span.textContent = day(inv.due_date) + (due < today ? ' · ' + Math.round((today - due) / 86400000) + ' days past due' : '');
        cell(tr, null, span);
      } else {
        cell(tr, 'dash-table__muted', inv.due_date ? day(inv.due_date) : '—');
      }

      var st = document.createElement('span');
      st.className = 'dash-status dash-status--' + (inv.open ? 'progress' : 'good');
      st.textContent = inv.status || (inv.open ? 'Open' : 'Paid');
      cell(tr, null, st);
      cell(tr, 'dash-table__num', money(inv.total));
      cell(tr, 'dash-table__num dash-table__strong' + (inv.open ? '' : ' is-paid'), inv.open ? money(inv.balance) : 'Paid');
      var acts = document.createElement('span');
      acts.className = 'dealer-invoices__acts';
      acts.appendChild(pdfLink(inv, 'PDF'));
      /* Mobile QA 2026-10-14 (M19): open invoices can be paid from this list; the dashboard
         owns the pay dialog, so Pay opens it there for this invoice (?pay=<id>). */
      if (inv.open && payEnabled && inv.payable !== false && /^\d+$/.test(String(inv.id))) {
        var pay = document.createElement('a');
        pay.className = 'dash-table__pay';
        pay.href = DASHBOARD_URL + '?pay=' + encodeURIComponent(inv.id);
        pay.textContent = 'Pay';
        pay.setAttribute('aria-label', 'Pay invoice ' + (inv.number || inv.id));
        acts.appendChild(pay);
      }
      cell(tr, 'dash-table__act', acts);
      tbody.appendChild(tr);
    });

    var what = rows.length + (rows.length === 1 ? ' invoice' : ' invoices');
    var range = p.from || p.to ? ' from ' + (p.from ? day(p.from) : 'the start') + ' to ' + (p.to ? day(p.to) : 'today') : '';
    el('[data-invoice-summary]').textContent = what + range + (owed > 0 ? ' · ' + money(owed) + ' outstanding' : '');
    el('[data-invoice-card]').hidden = !rows.length;
    el('[data-invoice-empty]').hidden = !!rows.length;
  }

  function load(p) {
    el('[data-invoice-loading]').hidden = false;
    el('[data-invoice-card]').hidden = true;
    el('[data-invoice-empty]').hidden = true;
    var qp = new URLSearchParams(p);
    if (scopeParam()) qp.set('location', scopeParam());
    var q = qp.toString();
    fetch(PROXY + '/invoices/lookup?' + q, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        el('[data-invoice-loading]').hidden = true;
        if (!res.ok) { el('[data-invoice-summary]').textContent = 'Something went wrong. Please try again.'; return; }
        render(res.body.invoices || [], p);
      })
      .catch(function () {
        el('[data-invoice-loading]').hidden = true;
        el('[data-invoice-summary]').textContent = 'Something went wrong. Please try again.';
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var p = paramsFromForm();
    if (!p.q && !p.from && !p.to && !p.open) { p.from = isoDaysAgo(DAYS); fillForm(p); }
    history.replaceState(null, '', location.pathname + '?' + new URLSearchParams(p).toString());
    load(p);
  });

  var initial = {};
  new URLSearchParams(location.search).forEach(function (v, k) { if (['q', 'from', 'to', 'open'].indexOf(k) !== -1 && v) initial[k] = v; });
  if (!initial.q && !initial.from && !initial.to && !initial.open) initial.from = isoDaysAgo(DAYS);
  fillForm(initial);
  load(initial);
})();
